import {Navigate, Outlet} from "react-router-dom";
import {useAuth} from "./AuthContext";

import { LoadingAnimatedPage } from "../components/Loading";

export default function ProtectedRoute() {
    const {user, loading} = useAuth();

    if(loading) {
        return (
            <LoadingAnimatedPage />

        );
    }

    if(!user) {
        return <Navigate to="login" replace />;
    }

    return <Outlet />;

}